import { Trash2 } from 'lucide-react';

import { SPAN_TYPES, TAG_META, fieldFor, operationFor, spanProblem } from '../../../lib/spans.js';
import { SpanOutcome } from '../SpanOutcome.jsx';

/**
 * The old `.annotation-span-grid`: one panel per tag type, each listing its spans with
 * operation, replacement and note.
 *
 * Three panels now rather than four - `unverifiable` was retired.
 */
export function SpanGrid({ spans, cursor, onCursor, onUpdate, onRetag, onRemove }) {
  return (
    <div className="annotation-span-grid">
      {SPAN_TYPES.map((label) => {
        const meta = TAG_META[label];
        const entries = spans
          .map((span, index) => ({ span, index }))
          .filter(({ span }) => span.label === label);

        return (
          <section className={`fact-box label-${label}`} key={label}>
            <h4>
              {meta.label} <span>{entries.length}</span>
            </h4>

            {entries.length === 0 ? (
              <p className="muted">No spans.</p>
            ) : (
              entries.map(({ span, index }) => {
                const field = fieldFor(span.label);
                const operation = operationFor(span.label, span);
                const problem = spanProblem(span);
                return (
                  <div
                    className={`span-editor ${meta.className} ${index === cursor ? 'cursor' : ''} ${
                      problem ? 'incomplete' : ''
                    }`}
                    key={`${span.start_char}-${span.end_char}`}
                    onClick={() => onCursor(index)}
                  >
                    <div className="span-editor-text" title={span.text}>
                      {span.text}
                    </div>

                    {field ? (
                      <input
                        className="input sm"
                        placeholder={field.placeholder}
                        value={span[field.key] || ''}
                        aria-label={field.label}
                        onChange={(e) => onUpdate(index, { [field.key]: e.target.value })}
                      />
                    ) : (
                      <span className="tiny faint">the hedge is removed</span>
                    )}



                    <div className="span-editor-foot">
                      <select
                        className="select sm"
                        value={span.label}
                        aria-label="Tag type"
                        onChange={(e) => onRetag(index, e.target.value)}
                      >
                        {SPAN_TYPES.map((l) => (
                          <option key={l} value={l}>
                            {TAG_META[l].label}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn sm danger"
                        onClick={() => onRemove(index)}
                      >
                        <Trash2 size={12} /> Remove
                      </button>
                    </div>

                    <SpanOutcome span={span} compact />
                    {problem && <span className="span-problem">{problem}</span>}
                  </div>
                );
              })
            )}
          </section>
        );
      })}
    </div>
  );
}
